<!-- SVG Gradient Definition for Icons -->
<svg width="0" height="0" style="position: absolute;">
  <defs>
    <linearGradient id="icon-gradient" x1="0%" y1="100%" x2="3.5%" y2="0%" gradientUnits="objectBoundingBox">
      <stop offset="0%" style="stop-color:rgb(255, 73, 73);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(113, 50, 99);stop-opacity:1" />
    </linearGradient>
  </defs>
</svg>

<!-- Floating Shapes Background -->
<!-- <div class="floating-shapes">
  <div class="shape"></div>
  <div class="shape"></div>
  <div class="shape"></div>
</div> -->

<!-- Main Content Wrapper -->
<div class="main-content-wrapper">
  <!-- Header with Logo -->
  <div class="header">
    <!-- <img src="./assets/images/Logo.png" alt="Logo" /> -->
  </div>

  <!-- Profile Dropdown -->
  <div class="profile-container" (click)="showDropdown = !showDropdown">
    <img src="./assets/images/user.png" alt="Profile Picture" />
    <span class="profile-name">{{ currentUserName }}</span>
    <i class="fas fa-caret-down profile-arrow"></i>
  </div>

  <!-- Dropdown Menu (separate from profile-container) -->
  <ul class="dropdown-menu dropdown-usermenu pull-right" *ngIf="showDropdown">
    <li><a class="dropdown-item" (click)="logout()"><i class="fa fa-sign-out"></i> {{ 'users.moduleSelection.logout' | translate }}</a></li>
  </ul>

  <!-- Main Container -->
  <div class="container">
    <!-- Pending Return URL Message -->
    <div *ngIf="pendingReturnUrl" style="margin-bottom: 30px; padding: 0 2rem; width: 100%;">
      <div style="max-width: 700px; margin: 0 auto;">
        <div class="alert alert-info" style="padding: 20px; border-radius: 12px; background-color: #d1ecf1; border: 1px solid #bee5eb; color: #0c5460; text-align: center; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
          <i class="fas fa-info-circle" style="margin-right: 10px; font-size: 18px;"></i>
          <div style="font-size: 16px; font-weight: 600; margin-bottom: 8px;">
            <strong>{{ 'users.moduleSelection.redirectingTo' | translate }}</strong> {{ pendingReturnUrl }}
          </div>
          <div style="font-size: 14px; opacity: 0.8;">
            {{ 'users.moduleSelection.selectModuleMessage' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="spinner"></div>
      <p>{{ 'users.moduleSelection.loadingModules' | translate }}</p>
    </div>

    <!-- No Modules Message -->
    <div *ngIf="!isLoading && modules.length === 0" class="no-modules-container">
      <div class="card" style="padding: 40px; border-radius: 12px; box-shadow: 0 0 15px rgba(0,0,0,0.1);">
        <h2 style="font-size: 28px; color: #333; font-weight: bold;">
          {{ 'users.moduleSelection.noModulesAvailable' | translate }}
        </h2>
      </div>
    </div>

    <!-- Module Cards -->
    <div *ngIf="!isLoading && modules.length > 0"
         class="dashboard"
         [ngClass]="{'center-single-card': modules.length === 1}">
      <div class="card" *ngFor="let module of modules">
        <!-- Module Icon -->
        <i [class]="module.logo + ' icon'"></i>

        <!-- Module Name -->
        <h2>{{ module.name }}</h2>

        <!-- Module Description (if available) -->
        <!-- <p *ngIf="module.description" class="description">{{ module.description }}</p> -->

        <!-- Role Selection (Multiple Roles) - Custom Dropdown -->
        <div *ngIf="module.roles.length > 1" class="role-selector">
          <div class="custom-dropdown" [class.open]="module.dropdownOpen">
            <!-- Dropdown Button -->
            <button
              type="button"
              class="dropdown-button"
              (click)="toggleDropdown(module)"
              [class.has-selection]="module.selectedRole">
              <span class="dropdown-label">
                <i class="fas fa-user-tag dropdown-icon"></i>
                {{ module.selectedRole ? module.selectedRole.name : ('users.moduleSelection.selectRole' | translate) }}
              </span>
              <i class="fas fa-chevron-down dropdown-arrow" [class.rotate]="module.dropdownOpen"></i>
            </button>

            <!-- Dropdown Menu -->
            <div class="dropdown-options" *ngIf="module.dropdownOpen">
              <div
                *ngFor="let role of module.roles; let i = index"
                class="dropdown-option"
                [class.selected]="module.selectedRole?.id === role.id"
                (click)="selectRole(module, role)">
                <div class="option-content">
                  <i class="fas fa-user-shield option-icon"></i>
                  <span class="option-text">{{ role.name }}</span>
                </div>
                <i class="fas fa-check option-check" *ngIf="module.selectedRole?.id === role.id"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Single Role Display -->
        <div *ngIf="module.roles.length === 1" class="single-role-display">
          <p><strong>{{ 'users.moduleSelection.roleLabel' | translate }}</strong> {{ module.roles[0].name }}</p>
        </div>

        <!-- Continue Button -->
        <button
          type="button"
          (click)="goToModule(module)"
          [disabled]="module.roles.length > 1 && !module.selectedRole">
          {{ 'users.moduleSelection.continue' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
